import { useState } from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Box, Container } from '@components/layout/Grid';
import { BundleQuery } from '@gql/generated';
import {
  Title,
  SubTitle,
  CategoryTitle,
  VideoWrapper,
  TextWrapper,
} from '@ecosystems/landing_pages/hero/components';
import Hero, { Thumbnail } from '@ecosystems/landing_pages/hero/Hero';
import { Button } from '@components/ButtonV2';

const Wrapper = styled(Container)`
  // background-color: #f7f7f7;
`;

const Section = styled(Hero)`
  width: 100%;
  padding: 0;

  ${CategoryTitle} {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    margin-top: 20px;
    margin-bottom: 15px;

    svg {
      margin-right: 5px;
    }
    i {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  ${Title} {
    font-size: 24px;
    color: #242424;
  }

  ${SubTitle} {
    max-width: 500px;
    width: 100%;
    font-size: 14px;
    line-height: 22px;
  }

  ${Thumbnail} {
    height: auto;
    aspect-ratio: 3 / 2;
    object-fit: cover;
    border-radius: 5px;
  }

  ${TextWrapper} {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }

  ${VideoWrapper} {
    display: flex;
    align-items: center;
    border-radius: 5px;
    overflow: hidden;

    img {
      height: auto;
      aspect-ratio: 3 / 2;
    }
  }

  @media (min-width: ${({ theme }) => theme.viewports.tablet}px) {
    ${TextWrapper} {
      padding-left: 40px;
    }
    ${VideoWrapper} {
      padding: 0 40px 0 0;
    }
  }
`;

const GetAccessButton = styled(Button)``;

type Props = {
  content: BundleQuery['bundle']['infoPanel2'];
  fallbackImage: string;
};

export const InfoPanel2Section = (props: Props) => {
  const { content, fallbackImage } = props;
  const [showMore, setShowMore] = useState(false);

  if (!content) {
    return null;
  }

  const toggleReadMore = (e) => {
    e.preventDefault();
    setShowMore(!showMore);
    if (showMore === true) {
      document
        .getElementById('InfoPanel2')
        .scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Wrapper py={40} px={20} fullWidth>
      <Container>
        <Section
          titleAs="h2"
          title={content?.title}
          image={content?.image ?? fallbackImage}
          description={
            <div
              dangerouslySetInnerHTML={{
                __html: showMore ? content?.longText : content?.previewText,
              }}
            ></div>
          }
          actions={
            content?.longText
              ? [
                  <Box my={20}>
                    <GetAccessButton link onClick={toggleReadMore}>
                      {!showMore ? (
                        <Trans id="pausa-smart.read-more" />
                      ) : (
                        <Trans id="pausa-smart.read-less" />
                      )}
                    </GetAccessButton>
                  </Box>,
                ]
              : []
          }
        />
      </Container>
    </Wrapper>
  );
};
